import "bootstrap-icons/font/bootstrap-icons.css";
import { LinkButton } from "components/buttons";
import EnquiryForm from "components/forms/EnquiryForm";
import { ASSETS_BASE_URL } from "constants";
import { JumbotronBiz } from "sections";

function Deposit() {
  return (
    <div>
      <section className="section jumbotron">
        <JumbotronBiz
          badgeText="Financing"
          title={`
             <div style=" align-items: baseline;">
              Structured Commodity
                <span className="jumbotron-subtitle-2">
                 Financing<i>-i</i>
                    </span>
            </div>`}
          buttonText="Reach out to us!"
        />
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>About</h3>
          </div>
          <div className="col-xl-8">
            <p>
              alrajhi bank Malaysia's Structured Commodity Financing-i offers: 
            </p>
            <p>
              <ul>
                <li>
                  From financing long-term industrial projects to pumping in
                  capital for everyday trade activities to contract and asset
                  financing
                </li>
                <li>
                  The flexibility to settle your financing through deferred
                  monthly instalments on a pre-agreed financing rate. With this
                  vehicle, you can now leverage on our global expertise to
                  mitigate your costs and maximise profitability.
                </li>
              </ul>
            </p>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div
          className="row container align-item-center"
          style={{ justifyContent: "flex-start" }}
        >
          <div className="col-xl-4">
            <h3>Benefits</h3>
          </div>
          <div className="col-xl-8">
            <div className="features-container flex-wrap">
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Concept</div>
                <div className="column-subheader-2">
                  Offered under concept of Bai' Bithaman Ajil
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Approval</div>
                <div className="column-subheader-2">Fast approval </div>
              </div>
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Profit Rates</div>
                <div className="column-subheader-2">
                  Competitive floating profit rates{" "}
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Shariah Compliance</div>
                <div className="column-subheader-2">
                  Stringent Shariah-compliance{" "}
                </div>
              </div>
            </div>
            <br />
            <LinkButton
                text="Product Disclosure Sheet"
                onClick={() =>
                  window.open(
                    `${ASSETS_BASE_URL}assets/pdf/business-financing/PDS+-+Structured+Commodity+Financing-i.pdf`
                  )
                }
              />
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "flex-start" }}>
          <div className="col-xl-4">
            <h3>Reach out to us! </h3>
            <p>
              Share your details, and we'll get back to you as soon as possible.
            </p>
          </div>
          <div className="col-xl-8">
            <EnquiryForm />
          </div>
        </div>
      </section>
    </div>
  );
}

export default Deposit;
